var map = {
	"./de/title.png": "syBx",
	"./en/title.png": "xjuY",
	"./es/title.png": "P4VZ",
	"./fr/title.png": "fjve",
	"./ja/title.png": "fr+Z",
	"./ko/title.png": "RQ2B",
	"./pt/title.png": "dmJD",
	"./ru/title.png": "KZmr",
	"./tc/title.png": "VFmK",
	"./th/title.png": "C39Y"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Y4n7";